import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StewartFunctions } from '@functions/stewart.service';
import { Store } from '@ngxs/store';
import LogRocket from 'logrocket';
import { Observable, throwError } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { IntegrationsSelectors } from './integrations.selectors';
import { AppState } from '@state/app/app.state';
import { INTEGRATION_TYPES, IntegrationCardConfig, INTEGRATIONS } from '.';
import { BusinessFeatureFlagSelectors } from '@state/business';
import { TestHooks } from './integrations.hooks';

@Component({
	selector: 'app-integrations',
	templateUrl: './integrations.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IntegrationsComponent {
	testHooks = TestHooks;
	public INTEGRATION_TYPES = INTEGRATION_TYPES;
	public currentFilterKey: INTEGRATION_TYPES = null;

	public currentFilter(
		integrations: {
			key: INTEGRATION_TYPES;
			value: IntegrationCardConfig;
		},
		key: INTEGRATION_TYPES,
	): boolean {
		return key ? integrations.key === key : true;
	}
	// Order matters here
	public integrationsMap: Map<
		INTEGRATION_TYPES,
		Observable<Map<string, IntegrationCardConfig>>
	> = new Map(
		[
			INTEGRATION_TYPES.ElectronicMortgageInstructions,
			INTEGRATION_TYPES.PracticeManagement,
			INTEGRATION_TYPES.TitleInsurance,
			INTEGRATION_TYPES.PropertyAndWritsSearching,
			INTEGRATION_TYPES.IdentityVerification,
			INTEGRATION_TYPES.ElectronicSigning,
		]
			.filter((integrationType) => {
				switch (integrationType) {
					case INTEGRATION_TYPES.PracticeManagement:
						return this.store.selectSnapshot(AppState.loadedFromLeap);
					case INTEGRATION_TYPES.ElectronicSigning:
						return this.store.selectSnapshot(
							BusinessFeatureFlagSelectors.sc16163EnableSignIt,
						);
					default:
						return true;
				}
			})
			.map((key) => [
				key,
				this.store.select(IntegrationsSelectors[key]).pipe(
					map((value) => {
						if (key === INTEGRATION_TYPES.TitleInsurance) {
							value.set(INTEGRATIONS.STEWART_TITLE, {
								...value.get(INTEGRATIONS.STEWART_TITLE),
								connected$: this.stewartFunctions
									.connected_v2()
									.pipe(startWith(undefined)), // deprecation warning is incorrect here as long as null or undefined is passed
							});
						}
						return value;
					}),
					catchError((err) => {
						LogRocket.log(
							'Integrations - error when fetching integrations',
							err,
						);
						return throwError(err);
					}),
				),
			]),
	);

	constructor(
		private stewartFunctions: StewartFunctions,
		private store: Store,
	) {}

	keyValuePipeComparator = () => 0;
}
